var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconmeetFigma = function SvgIconmeetFigma(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.032 14.877a1 1 0 0 1 1.217-.72A5.002 5.002 0 0 1 23 19v2a1 1 0 1 1-2 0v-2a3.002 3.002 0 0 0-2.25-2.905 1 1 0 0 1-.718-1.218ZM14.573 2.916a1 1 0 0 1 1.302-.552 5.001 5.001 0 0 1 0 9.272 1 1 0 0 1-.75-1.854 3.001 3.001 0 0 0 0-5.564 1 1 0 0 1-.552-1.302ZM7.179 14h4.642c1.09 0 1.835 0 2.473.17a5 5 0 0 1 3.536 3.536c.23.86.163 1.778.17 2.658.001.107.003.323-.051.524a1.5 1.5 0 0 1-1.06 1.06c-.202.055-.418.053-.525.052a860.571 860.571 0 0 0-13.728 0c-.107.001-.323.003-.524-.051a1.5 1.5 0 0 1-1.06-1.06c-.055-.202-.053-.418-.052-.525.007-.878-.06-1.8.17-2.658a5 5 0 0 1 3.536-3.536C5.344 14 6.088 14 7.179 14Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z",
    fill: "#000"
  })));
};
export default SvgIconmeetFigma;